import styled from "styled-components";

import { Strip } from "manager/components/app-summary/action-bar/DealBanner/styled";

/* Spec §01 — the "Why this recommendation" + "What VERO1 changed" rules inside
   the banner's dark strip (.lg-strip). Every value mirrors a spec rule 1:1. */

/* recommendation strip: rationale rule grows, changed-items rule fixed at
   430px; wraps on narrow widths */
export const StripLayout = styled(Strip)`
  display: flex;
  gap: 32px;
  flex-wrap: wrap;
`;

export const Rule = styled.div`
  border-left: 3px solid #6e4fc0;
  padding-left: 16px;
  flex: 1 1 0;
  min-width: min(100%, 320px);
`;

export const ChangedRule = styled(Rule)`
  flex: 0 0 430px;
  max-width: 100%;
`;

export const RuleHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 7px;
`;

/* .lg-rlbl{font:600 10px 'Work Sans';letter-spacing:.13em;
   text-transform:uppercase;color:#B39BEC} */
export const RuleLabel = styled.span`
  font: 600 10px "Work Sans", sans-serif;
  letter-spacing: 0.13em;
  text-transform: uppercase;
  color: #b39bec;
`;

export const RuleHairline = styled.span`
  height: 1px;
  flex: 1;
  background: rgba(255, 255, 255, 0.1);
`;

/* inert until PRODUCT-2060 defines the destination */
export const ViewDetails = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  padding: 0;
  color: #b39bec;
  font: 500 11.5px "Work Sans", sans-serif;
  cursor: default;
  flex: 0 0 auto;
`;

export const SectionCount = styled.span`
  font: 300 11.5px "Work Sans", sans-serif;
  color: #a9a3c9;
  flex: 0 0 auto;
`;

/* .lg-body{font:300 14px/1.7 'Work Sans';color:#E7E4F2;margin:0} */
export const RationaleText = styled.p`
  font: 300 14px/1.7 "Work Sans", sans-serif;
  color: #e7e4f2;
  margin: 0;
`;

/* screening facts as the review's own reasoning — same voice as the
   rationale paragraph, one line per finding */
export const WhyLineList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  font: 300 13px/1.7 "Work Sans", sans-serif;
  color: #e7e4f2;
  ${RationaleText} + & {
    margin-top: 8px;
  }
  li + li {
    margin-top: 2px;
  }
`;

export const ChangedList = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ChangedRow = styled.div`
  display: flex;
  flex-direction: column;
`;

/* the row line carries the divider; the expanded detail sits beneath it */
export const RowHeader = styled.div<{ $expandable?: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 7px 0;
  border: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
  background: none;
  text-align: left;
  font: inherit;
  cursor: ${({ $expandable }) => ($expandable ? "pointer" : "default")};
`;

export const Chevron = styled.span<{ $open?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 11px;
  flex: 0 0 auto;
  transform: ${({ $open }) => ($open ? "rotate(90deg)" : "none")};
  svg {
    stroke: ${({ $open }) => ($open ? "#B39BEC" : "#A9A3C9")};
  }
`;

export const ItemName = styled.span<{ $open?: boolean }>`
  font: ${({ $open }) => ($open ? 400 : 300)} 12.5px "Work Sans", sans-serif;
  color: #e7e4f2;
  flex: 1;
  min-width: 0;
`;

/* which applicant a per-applicant row belongs to — same label rows (Identity
   Verification on each applicant) are otherwise indistinguishable */
export const RowApplicant = styled.span`
  font: 300 11.5px "Work Sans", sans-serif;
  color: #a9a3c9;
`;

export const ActionMarker = styled.span`
  display: inline-flex;
  align-items: center;
  height: 19px;
  padding: 0 8px;
  border-radius: 2px;
  background: rgba(220, 196, 156, 0.16);
  font: 500 10.5px "Work Sans", sans-serif;
  color: #dcc49c;
  flex: 0 0 auto;
`;

export const ValuePill = styled.span`
  font: 500 12.5px "Work Sans", sans-serif;
  color: #edebf5;
  flex: 0 0 auto;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 5px;
`;

/* one row's findings and its action, indented under the row that carries them */
export const RowDetail = styled.div`
  padding: 7px 0 9px 21px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ReasonLabel = styled.span`
  font: 500 10px "Work Sans", sans-serif;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #a9a3c9;
`;

export const Findings = styled.span`
  font: 300 12.5px/1.5 "Work Sans", sans-serif;
  color: #c8c3dc;
`;

export const ActionNeeded = styled.span`
  font: 300 12.5px/1.5 "Work Sans", sans-serif;
  color: #dcc49c;
  b {
    font-weight: 500;
  }
`;
